import React, { Component } from 'react';
// import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import './CategoryManage.scss';
import { getAllCategories, createNewCategoryService, deleteCategoryService, editCategoryService } from '../../../services/categoryService';
// import getAllCountries from '../../../services/countryService';
import ModalCategory from './ModalCategory';
import ModalEditCategory from './ModalEditCategory';
import { emitter } from '../../../utils/emitter' // ham tao su kien
import { getAllCountries } from '../../../services/countryService';
import { isMetaProperty } from 'typescript';
class CategoryManage extends Component {

    constructor(props) { // Ham khoi tao
        super(props);
        this.state = {
            arrCategories: [],
            arrCountries: [],
            isOpenModal: false,
            isOpenModalEditCategory: false,
            CategoryEdit: [],

        }

    }

    async componentDidMount() {  // set bien, goi api
        await this.getAllCategoryFromReact()

    }
    getAllCategoryFromReact = async () => {
        let response = await getAllCategories("All");
        let responseCountry = await getAllCountries("All");

        if (response && response.errCode === 0) {
            this.setState({
                arrCategories: response.categories,
                arrCountries: responseCountry.countries
            })
            console.log(this.state.arrCountries);
        }
    }
    createNewCategory = async (data) => {

        try {
            let response = await createNewCategoryService(data);
            if (response && response.errCode !== 0) {
                await this.getAllCategoryFromReact()
                this.setState({
                    isOpenModal: false,
                })
                emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });

            } else {
                console.log("Category didn't create");
            }

        } catch (error) {

        }
    }
    editCategory = async (data) => {
        try {
            let response = await editCategoryService(data);
            if (response && response.errCode !== 0) {
                await this.getAllCategoryFromReact()
                this.setState({
                    isOpenModalEditCategory: false,
                })
                // emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });
                console.log('trang thai tra ve ham edit: ', response)
            } else {
                console.log("Category didn't create");
            }

        } catch (error) {

        }
    }
    handleAddNewCategory = () => {
        this.setState({
            isOpenModal: true
        })
        // alert("from handleAddNewCategory");
    }
    handleDeleteCategory = async (data) => {

        let response = await deleteCategoryService(data);
        if (response && response.errCode !== 0) {
            await this.getAllCategoryFromReact()
            this.setState({
                isOpenModal: false,
            })

        } else {
            console.log("Category didn't create");
        }

    }
    handleEditCategory = async (data) => {

        this.setState({
            isOpenModalEditCategory: true,
            CategoryEdit: data
        })
    }
    toogleCategoryModal = () => {
        this.setState({
            isOpenModal: !this.state.isOpenModal
        })
    }
    toogleCategoryEditModal = () => {
        this.setState({
            isOpenModalEditCategory: !this.state.isOpenModalEditCategory
        })
    }
    render() {
        console.log('check render : ', this.state.isOpenModal);
        console.log('check all country : ', this.state.arrCountries);
        let arrCategories = this.state.arrCategories;
        // console.log('check render : ', arrCategorys);
        // props - properties, nested, lay data tu Thang cha chuyen cho thang con, thang cha lay du lieu goc tu API
        return (
            <div className="categories-container">
                <ModalCategory
                    isOpen={this.state.isOpenModal}
                    tooglefromParent={this.toogleCategoryModal}
                    createNewCategory={this.createNewCategory}
                    countries={this.state.arrCountries}
                />
                {this.state.isOpenModalEditCategory &&
                    <ModalEditCategory
                        isOpen={this.state.isOpenModalEditCategory}
                        tooglefromParent={this.toogleCategoryEditModal}
                        currentCategory={this.state.CategoryEdit}
                        editCurrentCategory={this.editCategory}
                        countries={this.state.arrCountries}

                    />
                }

                <div className='title text-center'> Manage Category by Admin</div>
                <div className="mx-1">
                    <button class="btn btn-primary px-3"
                        onClick={() => this.handleAddNewCategory()}
                    ><i class="fas fa-plus"></i>Add new Category</button>

                </div>
                <div className='category-table mt-3 mx-1'>
                    <table id="customers">
                        <tr>
                            <th>Name</th>
                            <th>Country</th>
                            <th>Level</th>
                            <th>Parent Id</th>
                            <th>Action</th>
                        </tr>

                        {/* su dung vong lap MAP function javascript */}
                        {arrCategories && arrCategories.map((item, index) => {
                            // console.log('check map', item, index);
                            return (
                                <tr>
                                    <td>{item.categoryName}</td>
                                    <td>{
                                        this.state.arrCountries.map((country, index) => {
                                            if (item.categoryCountry == country.id) {
                                                return country.countryName
                                                // alert(country.countryName)
                                            }
                                        })
                                    }</td>
                                    <td>{item.categoryLevel}</td>
                                    <td>{item.categoryParentId}</td>
                                    <td>
                                        <button className='btn-edit'
                                            onClick={() => this.handleEditCategory(item)}
                                        ><i class="fas fa-pencil-alt"></i></button>
                                        <button className='btn-delete'
                                            onClick={() => this.handleDeleteCategory(item)}
                                        > <i className="fas fa-trash-alt"></i></button>

                                    </td>
                                </tr>

                            )
                        })
                        }



                    </table>
                </div>
            </div >
        );
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryManage);
